function CenterLayout({ children }) {
	return (
		<div className="flex items-center justify-center bg-white dark:bg-gray-900">
			{children}
		</div>
	);
}

export default CenterLayout;